module.exports = __webpack_public_path__ + "media/images/responsive/page_common/banner_stores/banner_stores_yokohama-7063b9b7640a60e2d8b3d41359255c9d.jpg";